import React from "react";
import { useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";
// import { casinoTabs } from "../../lib/data";
// import { slotsData, casinoGames } from "../../lib/data/slots.data";
// import { GamesData } from "./GamesData";
// import { casinoTabs } from "../../lib/data";
import { gamesData } from "../../lib/data/searchGamesData";
import SearchIcon from "../../assets/images/icons/find.png";
import { KingmakerGames } from "../../lib/data/KingmakerGames.data";
import { casinoSection } from "../../lib/data/casinosection.data";
import { casinoTabs } from "../../lib/data";
import { PragmaticPlayGames } from "../../lib/data/pragmaticplayGames.data";

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState(false);

  const totalGames = [
    ...Object.values(casinoSection.roulettetab || {}),
    ...Object.values(casinoSection.AndarBahar || {}),
    ...Object.values(casinoSection.popularGames || {}),
    ...Object.values(casinoSection.dragontiger || {}),
    ...Object.values(casinoSection.baccarattab || {}),
    ...Object.values(casinoSection.blackjacktab || {}),
    ...Object.values(casinoSection.pokertab || {}),
    ...Object.values(casinoTabs?.jiliGaming || {}),
    ...Object.values(KingmakerGames.kingmakerGames.slide1 || {}),
    ...Object.values(PragmaticPlayGames || {}),
  ];


  const handleSearch = (e) => {
    if (e) {
      setSearchText(true);

      let filteredValue = Object.values(totalGames)?.filter((item) => {
        return item.name.toLowerCase().indexOf(e?.toLowerCase()) > -1;
      });
      setFilteredData(filteredValue);
    } else {
      setSearchText(false);
    }
  };

  return (
    <>
      <div className="searchGames" onClick={handleShow}>
        <img src={SearchIcon} alt="search icon" />
        <p>Search Games</p>
      </div>

      <Modal show={show} onHide={handleClose} className="searchGames1">
        <Modal.Header closeButton>
          <Modal.Title>Search For Games</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3 search-icon">
            <Form.Control
              placeholder="Search"
              aria-label="Text input with dropdown button"
              type="search"
              onChange={(e) => handleSearch(e.target.value)}
              autoFocus
            />
          </InputGroup>
          <div className="GamesShow">
            {filteredData &&
              filteredData.map((item) => (
                <div className="displayGames">
                  <a href={item.redirectUrl || item.href}>
                    {item.imgUrl ? (
                      <img src={item.imgUrl} />
                    ) : (
                      <img src={item?.cover?.src} />
                    )}
                  </a>
                </div>
              ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GamesSearchModal;
